import { render, staticRenderFns } from "./AvatarSeletor.vue?vue&type=template&id=b36ef7dc&scoped=true"
import script from "./AvatarSeletor.vue?vue&type=script&lang=js"
export * from "./AvatarSeletor.vue?vue&type=script&lang=js"
import style0 from "./AvatarSeletor.vue?vue&type=style&index=0&id=b36ef7dc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36ef7dc",
  null
  
)

export default component.exports